export const profile = {
  'Top artists this month': 'Top artists this month',
  'Top tracks this month': 'Top tracks this month',
  Songs: 'Songs',
  'Only visible to you': 'Only visible to you',
  'Public playlists': 'Public playlists',
  Profile: 'Profile',
  Followers: 'Followers',
};
